module.exports = "/_next/static/images/b7f9a12d9700cab578eace3663d38803-aboutus-hiring-desktop.jpg";